/**
 * Traduction des identifiants clients Keycloak (champ `clientId`) en libellés FR
 * compréhensibles pour l'utilisateur final.
 *
 * Ces IDs désignent les applications OIDC auxquelles l'utilisateur s'est connecté
 * dans le cadre d'une session (ex. l'app Follow, la console admin Keycloak…).
 */
export const KEYCLOAK_CLIENT_LABELS: Record<string, string> = {
  'follow-app': 'Application Follow',
  'security-admin-console': "Console d'administration",
  account: 'Gestion du compte',
  'account-console': 'Gestion du compte',
  'admin-cli': 'Outil administrateur',
  broker: 'Connexion fédérée',
  'realm-management': 'Administration du realm',
}

/** Met en forme un clientId inconnu : "some-client_name" → "Some Client Name". */
export const humanizeClientId = (clientId: string): string =>
  clientId
    .split(/[-_]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')

/**
 * Traduit un `clientId` Keycloak en libellé affichable.
 * Retombe sur une mise en forme automatique si le client n'est pas mappé.
 */
export const translateClientId = (clientId: string): string => {
  const normalized = clientId.trim().toLowerCase()
  return KEYCLOAK_CLIENT_LABELS[normalized] ?? humanizeClientId(clientId.trim())
}
